var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('video',{staticStyle:{"height":"100%","width":"100%"},attrs:{"controlsList":"nodownload","oncontextmenu":"return false;","id":"videoPlayer","src":_vm.launchData.activityLink,"type":"video/mp4","controls":"","autoplay":""},on:{"loadeddata":_vm.initVideo,"play":_vm.startTimer,"pause":_vm.pauseTimer,"ended":_vm.postData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }